import {
    Typography,
    Button,
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    IconButton,
    Tooltip,
} from "@mui/material";
import { useState } from "react";
import { ArrowDownward, ArrowUpward, HelpOutline } from "@mui/icons-material";
import { IService } from "../../interfaces/IService";
import { ServiceCheckListItem } from "./ServiceCheckListItem";
import { ServiceCheckListItemDialog } from "./ServiceCheckListItemDialog";
import { getEmtyServiceCheckListItem, IServiceCheckListItem } from "../../interfaces/IServiceCheckListItem";

interface IProps {
    checkListItems: IServiceCheckListItem[];
    setCheckListItems: Function;
    service: IService;
}

export const ServiceCheckList: React.FC<IProps> = ({ checkListItems, setCheckListItems, service }) => {
    const [isAddCheckListItemOpen, setIsAddCheckListItemOpen] = useState<boolean>(false);
    return (
        <>
            {isAddCheckListItemOpen && (
                <ServiceCheckListItemDialog
                    isCheckListItemDialogOpen={isAddCheckListItemOpen}
                    setIsCheckListItemDialogOpen={setIsAddCheckListItemOpen}
                    checkListItem={getEmtyServiceCheckListItem(checkListItems, service)}
                    checkListItems={checkListItems}
                    setCheckListItems={setCheckListItems}
                ></ServiceCheckListItemDialog>
            )}

            <Box sx={{ pl: 2, pr: 2, pb: 2 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h6">Checkliste</Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setIsAddCheckListItemOpen(true);
                        }}
                    >
                        + Checklisteintrag
                    </Button>
                </Box>

                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell width="20%">Titel</TableCell>
                            <TableCell width="40%">Beschreibung</TableCell>
                            <TableCell width="15%">
                                <Tooltip
                                    title={"Checklisteintrag nach unten verschieben."}
                                    disableInteractive
                                    disableHoverListener={false}
                                >
                                    <span style={{ float: "right" }}>
                                        <IconButton disabled size="small" onClick={() => {}}>
                                            <ArrowDownward />
                                        </IconButton>
                                    </span>
                                </Tooltip>

                                <Tooltip
                                    title={"Checklisteintrag nach oben verschieben."}
                                    disableInteractive
                                    disableHoverListener={false}
                                >
                                    <span style={{ float: "right" }}>
                                        <IconButton disabled size="small" onClick={() => {}}>
                                            <ArrowUpward />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </TableCell>
                            <TableCell width="10%">
                                <Box display="flex" alignItems="center" gap={1}>
                                    Foto notwendig
                                    <Tooltip title="Bei Häkchen - Das Abhaken des Checklisteintrag ist erst nach dem Hochladen eines Fotos möglich.">
                                        <HelpOutline fontSize="small" />
                                    </Tooltip>
                                </Box>
                            </TableCell>
                            <TableCell width="15%">Bearbeiten</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {checkListItems
                            .sort((a, b) => (a.position < b.position ? -1 : 1))
                            .map((item, index) => (
                                <ServiceCheckListItem
                                    checkListItem={item}
                                    index={index}
                                    checkListItems={checkListItems}
                                    setCheckListItems={setCheckListItems}
                                ></ServiceCheckListItem>
                            ))}
                    </TableBody>
                </Table>
            </Box>
        </>
    );
};
